import { gql } from "@apollo/client";

export default gql`
  mutation updateUserNames(
    $userId: Int!
    $firstName: String
    $lastName: String
  ) {
    updateUser(id: $userId, firstName: $firstName, lastName: $lastName) {
      user {
        id
        firstName
        lastName
      }
    }
  }
`;
